<template>
  <div id="login-page">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
            <v-stepper v-model="curr" color="green">
                <v-stepper-header class="overflow-x-auto">
                    <v-stepper-step
                        v-for="(step, n) in steps"
                        :key="n"
                        :complete="stepComplete(n)"
                        :step="n + 1"
                        :rules="[value => !!step.valid]"
                        :color="stepStatus(n + 1)">
                        {{ step.name }}
                    </v-stepper-step>
                </v-stepper-header>
                <v-stepper-content v-for="(step, n) in steps" :step="n + 1" :key="n">
                    <!-- Step 1 -->
                    <form v-if="curr == 1" class="add-form">
                      <v-text-field
                          v-model="email"
                          label="Confirm your email (username)"
                          :rules="rules"
                          hide-details="auto"
                      ></v-text-field>
                      <transition name="hint" appear>
                        <div v-if="email.length > 0 && errorMessage.length > 0" class="hints">
                          <p>{{ errorMessage }}</p>
                        </div>
                        <div v-if="email.length > 0 && errorMessage.length === 0" class="hints">
                          <p>Your email is valid</p>
                        </div>
                        <div v-else class="hints">
                          <p/>
                        </div>
                        </transition>
                    </form>

                    <!-- Step 2 -->
                    <div v-if="curr == 2" id="set_pwd" v-cloak>

                        <div class="password">
                          <v-text-field
                              label="Choose your password"
                              hide-details="auto"
                              :class='{valid:passwordValidation.valid}'
                              :type="passwordVisible ? 'text' : 'password'"
                              v-model="password"
                          ></v-text-field>
                          <button class="visibility" tabindex='-1' @click='togglePasswordVisibility' :arial-label='passwordVisible ? "Hide password" : "Show password"'>
                            <i class="material-icons">{{ passwordVisible ? "visibility" : "visibility_off" }}</i>
                          </button>
                        </div>

                        <v-text-field
                            label="Confirm your password"
                            hide-details="auto"
                            :class='{valid:passwordValidation.valid}'
                            :type="passwordVisible ? 'text' : 'password'"
                            v-model.lazy='checkPassword'
                        ></v-text-field>

                        <transition name="hint" appear>
                          <div v-if="passwordValidation.errors.length > 0 && !submittedPwd" class="hints">
                            <p v-for='error in passwordValidation.errors' :key="error">{{error}}</p>
                          </div>
                          <div v-if='notSamePasswords' class="hints">
                            <p>Passwords not matching</p>
                          </div>
                          <div v-if='!notSamePasswords && passwordValidation.errors.length === 0' class="hints">
                            <p>Your password is valid</p>
                          </div>
                        </transition>
                    </div>

                    <v-btn v-if="n+1 < lastStep" color="primary" @click="validate(n)" :disabled="!step.valid">Next</v-btn>
                    <v-btn v-else color="success" @click="done()">Submit</v-btn>
                    <v-btn v-if="n > 0" text @click="curr = n">Back</v-btn>
                </v-stepper-content>
            </v-stepper>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import api from "@/api/api"

export default {
  name: "ActivateLogin",
  data() {
    return {
      // Email Step
      email: '',
      errorMessage: '',
      curr: 1,
      lastStep: 2,
      stepperCompleted: false,
      steps: [
          {name: "Step 1 : Email", rules: [v => !!v || "Requis."], valid: true},
          {name: "Step 2 : Password", rules: [v=> !!v || "Requis."], valid: true}
      ],
      rules: [],
      valid: false,
      stepForm: [],

      // Password Step
      pwdRules: [
				{ message: 'Must contain at least one lower case letter', regex:/[a-z]+/ },
				{ message: 'Must contain at least one upper case letter',  regex:/[A-Z]+/ },
        { message: 'Must contain at least one number', regex:/[0-9]+/ },
				{ message: 'Minimum 10 characters are required', regex:/.{10,}/ }
			],
			password: '',
			checkPassword: '',
			passwordVisible: false,
      submittedPwd: false,
    };
  },

  watch: {
    // Email Step
    email(value){
      this.email = value;
      this.validateEmail(value);
    }
  },

  computed: {
    // Password Step
		notSamePasswords () {
			if (this.passwordsFilled) {
				return (this.password !== this.checkPassword)
			} else {
				return false
			}
		},
		passwordsFilled () {
			return (this.password !== '' && this.checkPassword !== '')
		},
		passwordValidation () {
			let errors = []
			for (let condition of this.pwdRules) {
				if (!condition.regex.test(this.password)) {
					errors.push(condition.message)
				}
			}
			if (errors.length === 0) {
				return { valid: true, errors }
			} else {
				return { valid: false, errors }
			}
		}
	},

  methods: {
        // Stepper
        stepComplete(step) {
            return this.curr >= step
        },
        stepStatus(step) {
            return this.curr > step ? 'green' : !this.stepperCompleted ? 'blue' : 'green'
        },
        validate(n) {
          this.steps[n].valid = false

          if (n === 0 && this.errorMessage === '') {
            this.steps[n].valid = true
            this.curr = n + 2
          } else {
            this.steps[n].valid = true
            this.curr = n + 2
          }
        },
        done() {
            this.curr = 2
            this.steps[this.curr - 1].valid = true

            if (this.passwordsFilled && !this.notSamePasswords && this.passwordValidation.valid) {
              this.stepperCompleted = true
              this.stepStatus(this.curr - 1)

              // Check Token
               api
                .validateAccount(this.email, this.password, this.$route.params.token)

              setTimeout(() => {
                this.submittedPwd = false
                this.$router.push('/login')
              }, 2000)

            }
        },

        // Email Step
        validateEmail(email) {
          event.preventDefault()

          if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(email)) {
            this.errorMessage = ''
          } else {
            this.errorMessage = ' Your email is invalid'
          }
        },

        // Password Step
        // resetPasswords () {
        //   this.password = ''
        //   this.checkPassword = ''
        //   this.submittedPwd = true
        //   setTimeout(() => {
        //     this.submittedPwd = false
        //   }, 2000)
        // },
        togglePasswordVisibility () {
          this.passwordVisible = !this.passwordVisible
        },

    }
};
</script>

<style scoped>

.set_pwd {
  background: white;
}

[v-cloak] {
	opacity:0;
}

.hints {
	padding: 1em;
	background: whitesmoke;
	margin: 1em 0;
	font-size: .9em;
	color: dodgerblue;
	h2 {
		margin: .5em 0 .2em 0;
	}
	p {
		margin: 0;
		padding-left: 1em;
		&::before {
			//content: ">";
			font-size: .9em;
			margin-right: 6px;
			display: inline-block;
		}
	}
}

.visibility {
	all: unset;
	background: white;
	display: inline-block;
	padding: 2px .4em 0;
	vertical-align: center;
}

.material-icons {
	font-size: 1.5em;
}

.password {
	display: flex;
	align-items: center;
}

input, button {
	padding: 6px;
}

input + button {
	font-size: .85em;
}

[type=password], [type=text] {
	color: #000000;
	border: 1px solid lightgrey;
	//background: #3A81C8;
	margin: 6px 10px 6px 0;
	&.valid {

	}
}

[type=password] {
	letter-spacing: .2em;
}

.hint {
	&-enter {
		opacity: 0;
		transform: translate3d(-20px,0,0);
	}
	&-leave-to {
		opacity: 0;
		transform: translate3d(0, 20px, 0);
	}
	&-enter-active {
		transition: 300ms;
	}
	&-leave-active {
		transition: 400ms;
	}
}
</style>
